import React from "react"
import PropTypes from "prop-types"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'

const propTypes = {
    onLoadMore: PropTypes.func.isRequired,
    fetching: PropTypes.bool.isRequired,
    show: PropTypes.bool.isRequired
};

const LoadButton = (props) => {
    if (props.show) {
        return (
            <button
                className="btn btn-outline-blue px-3 mb-2"
                onClick={props.onLoadMore}
                disabled={props.fetching}
            >
                { props.fetching ? <FontAwesomeIcon icon={faCircleNotch} spin={true} className={"mr-2"}/> : "" }
                { " Load more" }
            </button>
        )
    } else {
        return null;
    }
};

LoadButton.propTypes = propTypes;

export default LoadButton;